import React, { useState } from "react";
import { toast } from "../ui/Toast";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const ACTIONS = [
  { status: "Closed",      label: "Close",        style: "border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400"       },
  { status: "Pending",     label: "Mark Pending",  style: "border-yellow-500/25 bg-yellow-500/8 text-yellow-400/70 hover:bg-yellow-500/15 hover:text-yellow-400" },
  { status: "In Progress", label: "In Progress",   style: "border-blue-500/25 bg-blue-500/8 text-blue-400/70 hover:bg-blue-500/15 hover:text-blue-400"   },
  { status: "Open",        label: "Reopen",        style: "border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90]" },
];

export default function TicketActions({ ticketId, refresh }) {
  const [busy,  setBusy]  = useState(null);
  const [error, setError] = useState(null);

  if (!ticketId) return null;

  const updateStatus = async (newStatus) => {
    setBusy(newStatus);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/tickets/update-status/${ticketId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      toast.success(`Status updated to ${newStatus}`);
      refresh?.();
    } catch (e) {
      setError(e.message);
      toast.error("Failed to update status");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Ticket Actions</span>
      </div>
      <div className="p-4 space-y-3">
        <div className="flex flex-wrap gap-2">
          {ACTIONS.map(({ status, label, style }) => (
            <button key={status} onClick={() => updateStatus(status)}
              disabled={busy !== null}
              className={`text-xs px-4 py-2 rounded-lg border transition-colors disabled:opacity-40 ${style}`}>
              {busy === status ? "Updating…" : label}
            </button>
          ))}
        </div>
        {error && <p className="text-red-400 text-xs">⚠ {error}</p>}
      </div>
    </div>
  );
}